<template>
  <div id="app">
    <router-view></router-view>
    <base-loading></base-loading>
  </div>
</template>

<script>
import BaseLoading from "./components/theme/BaseLoading.vue";
export default {
  components: {
    BaseLoading,
  },
  name: "app",
};
</script>
<style>
.language-div {
  position: relative;
}
.language-multiselect.multiselect {
  width: 150px;
  margin-top: 10px;
  margin-right: 10px;
  margin-left: auto;
}
</style>
